import { render, staticRenderFns } from "./jubao.vue?vue&type=template&id=aaa1b3c6&scoped=true"
import script from "./jubao.vue?vue&type=script&lang=js"
export * from "./jubao.vue?vue&type=script&lang=js"
import style0 from "./jubao.vue?vue&type=style&index=0&id=aaa1b3c6&prod&lang=scss"
import style1 from "./jubao.vue?vue&type=style&index=1&id=aaa1b3c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa1b3c6",
  null
  
)

export default component.exports